import React from "react";
import FundraisingList from "./FundraisingList";

const Fundraising = () => {
  return <FundraisingList />;
};

export default Fundraising;
